export interface SubscriptionStatus {
  status?: string | null;
  cancelAt?: string | Date | null;
}

export const isSubscriptionActive = (subscription: SubscriptionStatus | null | undefined): boolean => {
  if (!subscription) return false;

  const isActive = subscription.status
    ? (subscription.status === 'active' ||
       subscription.status === 'trialing' ||
       subscription.status === 'past_due')
    : (!subscription.cancelAt || new Date(subscription.cancelAt) > new Date());

  return isActive;
};

export const isSubscriptionIncomplete = (subscription: SubscriptionStatus | null | undefined): boolean => {
  if (!subscription || !subscription.status) return false;

  return subscription.status === 'incomplete' ||
         subscription.status === 'incomplete_expired';
};
